import { NativeStackScreenProps } from '@react-navigation/native-stack';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../store';
import BuyPackagesModal from '../Components/Modals/BuyPackagesModal';
import { RootStackParamList } from '../navigator';
type Props = NativeStackScreenProps<RootStackParamList, 'BuyPackages'>;

const ProfileScreen: React.FC<Props> = ({ navigation, route }) => {
	const user = useSelector((state: RootState) => state.auth.user);

	useEffect(() => {
		if (!user) navigation.replace('Login');
	}, [navigation, user]);

	if (!user) return null;

	return <BuyPackagesModal onClose={() => navigation.goBack()} route={route} renderInline />;
};

export default ProfileScreen;
